import React from 'react'
import useInput from 'tennders-common/form/hooks/useInput'
import stylesInput from '@/styles/Input.module.scss'

type Props = {
  className?: string
  labelClassName?: string
  label?: string
  errors?: Record<string, any>
  form?: Record<string, any>
  name?: string
  required?: boolean
  disabled?: boolean
  defaultText?: boolean
  onChange?: (key: string, value: any) => void
  renderInput?: (any) => JSX.Element
  style?: React.CSSProperties
}

const InputLabeledContainer = (props: Props) => {
  const {
    className = '',
    labelClassName = 'form-label',
    label = '',
    errors,
    form,
    name,
    required,
    disabled,
    onChange,
    renderInput,
    defaultText,
    style
  } = props

  const { errorContent, errorText, value, onSet } = useInput({
    errors,
    form,
    name,
    onChange
  })

  return (
    <div className={className} style={style || {}}>
      <label className={labelClassName}>
        {' '}
        {label}
        {required && <span className={stylesInput.required}>*</span>}
        {errorContent}
      </label>
      {renderInput({ error: errorText, name, onSet, value, disabled, defaultText, required })}
    </div>
  )
}

export default React.memo<Props>(InputLabeledContainer)
